<template>
  <div class="columns">
    <div class="column">
      <b-field
        v-if="ractivity.category && ractivity.type"
        :label="translate('subtype')"
        :type="{ 'is-danger': errors.has('subtype') }"
        :message="errors.first('subtype')"
      >
        <b-select
          :disabled="disabled"
          expanded
          name="subtype"
          v-validate="'required'"
          :placeholder="translate('subtype')"
          v-model="ractivity.subtype"
        >
          <option
            :value="csubtype"
            v-for="(csubtype, index) in getSubTypes(
              ractivity.category,
              ractivity.type
            )"
            :key="index"
          >
            {{ getDescription(csubtype) }}
          </option>
        </b-select>
      </b-field>
    </div>
    <div class="column is-4">
      <b-field
        :label="translate('amount')"
        :type="{ 'is-danger': errors.has('amount') }"
        :message="errors.first('amount')"
      >
        <b-input
          name="amount"
          :disabled="disabled"
          :placeholder="translate('amount')"
          v-validate="'required|decimal'"
          v-model="ractivity.amount"
        />
        <p class="control">
          <span class="button is-static">
            {{ $t(unit) }}
          </span>
        </p>
      </b-field>
    </div>
  </div>
</template>

<script>
import { ResearchActivity } from '@/models/carbon/ResearchActivity.js'

export default {
  name: 'DefaultInput',
  props: {
    ractivity: {
      type: Object,
      default: function () {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  inject: ['$validator'],
  computed: {
    unit: function () {
      return ResearchActivity.getUnit(
        this.ractivity.category,
        this.ractivity.type,
        this.ractivity.subtype
      )
    }
  },
  methods: {
    translate: function (key) {
      return ResearchActivity.translate(this.ractivity, key, this.$i18n.locale)
    },
    getSubTypes: function (category, type) {
      return ResearchActivity.getSubTypes(category, type)
    },
    getDescription: function (subtype) {
      return ResearchActivity.getDescription(
        this.ractivity.category,
        this.ractivity.type,
        subtype,
        this.$i18n.locale
      )
    }
  }
}
</script>
